import CandidatePositionInfo from './CandidatePositionInfo.component';

export default CandidatePositionInfo;
